import { Injectable } from '@angular/core';
import { CommonService } from '../../../shared/utils/common.service';
import { UtilsService } from '../../../shared/utils/utils.service';
import { Observable } from 'rxjs';
import { LogisticaDiccionario, logisticaModulo} from '../logistica-diccionario';
import { IAreaLogistica } from '../model/modelConfiguracional';


@Injectable({
    providedIn: 'root'
  })
  
export class TrackingConfiguracionService {

  urlLogistica  : string;
  diccionarioUrl: any;

  constructor(private commom: CommonService, private utilServices: UtilsService) {
    this.urlLogistica   = this.utilServices.getUrlLogistica();
    //this.urlLogistica   = "http://localhost:8080/logistica-api/v1/api/services/";
    this.diccionarioUrl = logisticaModulo.url;
  }


  /************** CATALOGOS ******** */
  getAllCatalogos(){
    let url = this.urlLogistica + this.diccionarioUrl.catalogos;
    return this.commom.peticionGetConHeader(url);
  }


  /************** CONFIGURACIONES DE TIPO ******** */
  getAllTipos(){
    let url = this.urlLogistica + this.diccionarioUrl.tipo_viajes;
    return this.commom.peticionGetConHeader(url);
  }

  getTipoById(idTipo){
    let url = this.urlLogistica + this.diccionarioUrl.tipo_viajes+"/"+idTipo;
    return this.commom.peticionGetConHeader(url);
  }

  saveTipos(payload){
    let url = this.urlLogistica + this.diccionarioUrl.tipo_viajes;
    return this.commom.peticionPostConHeader(url, payload);
  }

  updateTipos(payload){
    let url = this.urlLogistica + this.diccionarioUrl.tipo_viajes;
    return this.commom.peticionPutConHeader(url, payload);
  }

  deleteTipos(payload){
    let url = this.urlLogistica + this.diccionarioUrl.tipo_viajes;
    return this.commom.peticionDeleteConHeader(url, payload);
  }

  /************** CONFIGURACIONES DE AREA ******** */
  getAllAreas(): Observable<IAreaLogistica[]>{
    let url = this.urlLogistica + this.diccionarioUrl.areas;
    return this.commom.peticionGetConHeader(url);
  }

  getAllAreasActivas(): Observable<IAreaLogistica[]>{
    let url = this.urlLogistica + this.diccionarioUrl.areas+'/activas';
    return this.commom.peticionGetConHeader(url);
  }

   getAreasActivasbyCentro(PathParamCentro : String): Observable<IAreaLogistica[]>{
    let url = this.urlLogistica + this.diccionarioUrl.areas+'/centro/'+PathParamCentro+'/activas';
    return this.commom.peticionGetConHeader(url);
  }

  getAreasbyCentro(PathParamCentro : String): Observable<IAreaLogistica[]>{
    let url = this.urlLogistica + this.diccionarioUrl.areas+'/centro/'+PathParamCentro;
    return this.commom.peticionGetConHeader(url);
  }
  
  saveAreas(payload: IAreaLogistica){
    let url = this.urlLogistica + this.diccionarioUrl.areas;
    return this.commom.peticionPostConHeader(url, payload);
  }

  updateAreas(payload: IAreaLogistica){
    let url = this.urlLogistica + this.diccionarioUrl.areas;
    return this.commom.peticionPutConHeader(url, payload);
  }

  deleteAreas(payload: IAreaLogistica){
    let url = this.urlLogistica + this.diccionarioUrl.areas;
    return this.commom.peticionDeleteConHeader(url, payload);
  }

  /************** AREAS CAPACIDADES******** */





}